<template>
  <div id="ModalPassword">
    <transition name="fade">
      <div class="fixed inset-0 z-50" v-if="isModalVisible">
        <div
          class="absolute inset-0 bg-black bg-opacity-75"
          @click="onToggle"
        ></div>
        <div
          class="flex flex-col items-center justify-center w-screen h-screen"
        >
          <div class="relative animodal-inner">
            <div
              class="rounded-lg bg-white border border-stone-500 overflow-hidden"
            >
              <div class="mt-4 mb-3 pb-1 px-3 border-b-2 flex justify-between">
                <p>Update Password</p>
                <button
                  @click="onToggle"
                  class="bg-gray-200 text-sm text-gray-500 rounded-full h-6 w-6 hover:text-white hover:bg-gray-800 md:mb-0"
                >
                  <font-awesome-icon icon="fa-solid fa-xmark" />
                </button>
              </div>
              <div v-if="passwordUpdateSuccess" class="px-10 lg:px-32">
                <div class="text-center">
                  <div class="">
                    <font-awesome-icon
                      class="text-green-600 z-20 h-28 py-2"
                      icon="fa-check-circle"
                    />
                  </div>
                  <div class="py-2">
                    <div class="p-4 text-black">
                      <div class="text-lg font-bold text-center">
                        Password Successfully updated
                      </div>
                      <div class="mt-4 text-sm text-center font-normal">
                        <div class="block font-bold">
                          {{ passwordUpdateSuccess }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div v-if="passwordUpdateError" class="text-center lg:px-28">
                  <div class="">
                    <font-awesome-icon
                      class="text-red-600 z-20 h-28 py-2"
                      icon="fa-exclamation-circle"
                    />
                  </div>
                  <div class="py-2">
                    <div class="p-4 text-black">
                      <div class="text-lg font-bold text-center">
                        Password update request failed
                      </div>
                      <div class="mt-4 text-sm text-center font-bold">
                        {{ passwordUpdateError }}
                      </div>
                    </div>
                  </div>
                </div> -->
              <form
                v-else
                @submit.prevent="updatePassword"
                :class="{ valid: !v$.$error && v$.$dirty, error: v$.$error }"
                class="mx-5 mb-5 md:w-80"
              >
                <div
                  v-if="passwordUpdateError"
                  class="bg-red-600 text-white text-center my-3 rounded-md py-4"
                >
                  <font-awesome-icon
                    class="mr-2 text-sm"
                    icon="fa-exclamation-triangle"
                  />
                  {{ passwordUpdateError }}
                </div>
                <div>
                  <div>
                    <div>
                      <div>
                        <p class="block text-gray-700 text-sm mb-2">
                          <span class="text-red-500">*</span> Current Password
                        </p>
                        <div>
                          <input
                            v-model="state.currentPassword"
                            class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                            type="password"
                          />
                        </div>
                        <div
                          class="input-errors text-xs text-red-500 mt-1"
                          v-for="error of v$.currentPassword?.$errors"
                          :key="error.$uid"
                        >
                          <div class="error-msg">
                            Current password is required
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="mt-3">
                        <p class="block text-gray-700 text-sm mb-2">
                          <span class="text-red-500">*</span> New Password
                        </p>
                        <div>
                          <input
                            v-model="state.newPassword"
                            class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                            type="password"
                          />
                        </div>
                        <div
                          class="input-errors text-xs text-red-500 mt-1"
                          v-for="error of v$.newPassword?.$errors"
                          :key="error.$uid"
                        >
                          <div class="error-msg">New password is required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <div>
                      <div class="">
                        <p class="block text-gray-700 text-sm mb-2">
                          <span class="text-red-500">*</span> Confirm New
                          Password
                        </p>
                        <div class="flex">
                          <input
                            v-model="state.confirmPassword"
                            class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                            type="password"
                          />
                        </div>

                        <div
                          class="input-errors text-xs text-red-500 mt-1"
                          v-for="error of v$.confirmPassword?.$errors"
                          :key="error.$uid"
                        >
                          <div class="error-msg">
                            <div v-if="!error.required">
                              Confirm Password is required
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-2 mt-4 text-center space-x-4 md:block">
                  <button
                    :disabled="passwordUpdateLoading"
                    :class="
                      passwordUpdateLoading ? 'bg-gray-500' : 'bg-[#8DC63F]'
                    "
                    class="mb-2 w-full px-5 py-2 text-sm shadow-sm font-medium tracking-wider border text-white rounded-md hover:bg-orange-300 hover:shadow-lg md:mb-0"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { toolkitAxios } from "@/env";
export default {
  props: {
    isModalVisible: Boolean,
    onToggle: Function,
  },
  setup() {
    const passwordUpdateError = ref("");
    const passwordUpdateLoading = ref(false);
    const passwordUpdateSuccess = ref("");

    const state = reactive({
      newPassword: "",
      confirmPassword: "",
      currentPassword: "",
    });

    const rules = {
      newPassword: { required },
      currentPassword: { required },
      confirmPassword: { required },
    };

    const v$ = useVuelidate(rules, state);

    const updatePassword = async () => {
      v$.value.$touch();

      if (v$.value.$invalid) return;

      if (state.newPassword !== state.confirmPassword) {
        return (passwordUpdateError.value =
          "New password and Confirm password do not match");
      }

      passwordUpdateLoading.value = true;

      await toolkitAxios
        .post("employer/update-password", {
          current_password: state.currentPassword,
          new_password: state.newPassword,
        })
        .then(() => {
          passwordUpdateSuccess.value = "Password updated successfully";

          state.newPassword = "";
          state.confirmPassword = "";
          state.currentPassword = "";
          v$.value.$reset();
        })
        .catch(() => {
          passwordUpdateError.value =
            "Please make sure the current password is correct or try again later.";
        })
        .finally(() => {
          passwordUpdateLoading.value = false;
        });
    };

    return {
      state,
      rules,
      v$,
      passwordUpdateLoading,
      passwordUpdateSuccess,
      passwordUpdateError,
      updatePassword,
    };
  },
};
</script>

<style></style>
